function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "text_message_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 950",
  fill: "#e8f6f4",
  d: "M0 0h643.008v190.955H0z"
})));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8100"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8099"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8098",
  transform: "translate(-.001)",
  clipPath: "url(#text_message_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6610",
  d: "M632.261 0H11.078C5.036 0 0 6.536 0 14.938v117.656C0 141 5.036 148 11.08 148H37.6v38.285c0 1.868.672 3.734 2.015 4.2.336 0 1.008.467 1.343.467a2.74 2.74 0 002.351-1.4L73.193 148h558.735c6.044 0 11.08-7 11.08-15.408V14.937C643 6.536 637.969 0 632.261 0z",
  fill: "#e8f6f4"
}))), /*#__PURE__*/React.createElement("text", {
  "data-name": "\\u201CHi! It looks like your provider's job ends soon! Login to confirm or edit the total!\\u201D",
  transform: "translate(45.718 63.437)",
  fill: "#00a68d",
  fontSize: 20,
  fontFamily: "WorkSans-Bold, Work Sans",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 19
}, "\u201CHi! It looks like your provider\u2019s job ends soon! "), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 43
}, "Login to confirm or edit the total!\u201D")), /*#__PURE__*/React.createElement("text", {
  "data-name": "It\\u2019s as easy as this.",
  transform: "translate(45.718 26.437)",
  fill: "#002f4d",
  fontSize: 24,
  fontFamily: "WorkSans-Bold, Work Sans",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 22
}, "It\u2019s as easy as this.")));
var SvgTextMessage = function SvgTextMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 643.008 190.955"
  }, props), _ref, _ref2);
};
export default SvgTextMessage;